"use strict";
/**
 * This File is meant to hold and export commonly used functions.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.currentDate = exports.previousMonth = exports.pharmacyDropDownHandler = void 0;
const store_1 = require("../client/modules/sites/modules/sites-list/store");
/**
 *  This Method is used for material selects that need to reference a Pharamacy
 *  The THIS context of the method below will be the class in which the method is invoked
 *  If THIS context is not being properly referenced, you can use this binding to fix that issue.
 */
function pharmacyDropDownHandler(methodOptions) {
    if (!this.siteId || (this.siteId && e.length > 0)) {
        store_1.sitesListStore.loadSitesNoRelation(methodOptions);
    }
}
exports.pharmacyDropDownHandler = pharmacyDropDownHandler;
function previousMonth() {
    const date = new Date();
    date.setMonth(date.getMonth() - 1);
    const year = date.getFullYear();
    const month = date.getMonth() + 1 >= 10
        ? date.getMonth() + 1
        : '0' + (date.getMonth() + 1);
    const day = date.getDate() >= 10 ? date.getDate() : '0' + date.getDate();
    console.log(`${year}-${month}-${day}`);
    return `${year}-${month}-${day}`;
}
exports.previousMonth = previousMonth;
;
function currentDate() {
    const today = new Date();
    let dd = today.getDate();
    let mm = today.getMonth() + 1; // January is 0!
    const yyyy = today.getFullYear();
    if (dd < 10) {
        dd = '0' + dd;
    }
    if (mm < 10) {
        mm = '0' + mm;
    }
    return `${yyyy}-${mm}-${dd}`;
}
exports.currentDate = currentDate;
// export function convertMysqlDateTimeToDateString(mysqlDateTime: string): string {
// }



//////////////////
// WEBPACK FOOTER
// ./src/shared/util.ts
// module id = 245
// module chunks = 0